import { useState } from 'react';
import { User, X, ArrowRight, Star } from 'lucide-react';

const ProfilePromptModal = ({ isVisible, onClose, onGoToProfile }) => {
  const [isClosing, setIsClosing] = useState(false);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 200);
  };

  const handleGoToProfile = () => {
    setIsClosing(true);
    setTimeout(() => {
      onGoToProfile();
      setIsClosing(false);
    }, 200);
  };

  if (!isVisible) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '480px',
        width: '100%',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        transform: isClosing ? 'scale(0.95)' : 'scale(1)',
        opacity: isClosing ? 0 : 1,
        transition: 'all 0.2s ease-out',
        position: 'relative'
      }}>
        {/* Close button */}
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6b7280',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => {
            e.target.style.backgroundColor = '#f3f4f6';
            e.target.style.color = '#374151';
          }}
          onMouseOut={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#6b7280';
          }}
        >
          <X size={20} />
        </button>

        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #dc2626 0%, #1e40af 100%)',
            borderRadius: '12px',
            padding: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <User size={24} style={{ color: 'white' }} />
          </div>
          <div>
            <h2 style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#1f2937',
              margin: '0 0 4px 0'
            }}>
              Welcome to TravelFlow!
            </h2>
            <p style={{
              fontSize: '16px',
              color: '#6b7280',
              margin: '0'
            }}>
              Your first trip is ready
            </p>
          </div>
        </div>

        {/* Content */}
        <div style={{ marginBottom: '24px' }}>
          <p style={{
            fontSize: '16px',
            color: '#374151',
            lineHeight: '1.6',
            margin: '0 0 16px 0'
          }}>
            Great job creating your first trip! To get the most out of TravelFlow, we recommend setting up your profile with:
          </p>
          
          <div style={{
            background: '#f8fafc',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: '12px'
            }}>
              <Star size={16} style={{ color: '#f59e0b' }} />
              <span style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151'
              }}>
                Profile Benefits
              </span>
            </div>
            
            <ul style={{
              margin: '0',
              paddingLeft: '20px',
              color: '#6b7280',
              fontSize: '14px',
              lineHeight: '1.6'
            }}>
              <li style={{ marginBottom: '6px' }}>
                <strong style={{ color: '#374151' }}>Home address</strong> - Accurate departure time calculations
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong style={{ color: '#374151' }}>Phone number</strong> - SMS notifications for flight changes
              </li>
              <li style={{ marginBottom: '6px' }}>
                <strong style={{ color: '#374151' }}>TSA PreCheck/Clear</strong> - Optimized security wait times
              </li>
            </ul>
          </div>

          <p style={{
            fontSize: '14px',
            color: '#6b7280',
            lineHeight: '1.5',
            margin: '0'
          }}>
            Don't worry - you can always update your profile later from the Profile page.
          </p>
        </div>

        {/* Actions */}
        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={handleClose}
            style={{
              padding: '12px 20px',
              background: '#f3f4f6',
              color: '#374151',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.background = '#e5e7eb'}
            onMouseOut={(e) => e.target.style.background = '#f3f4f6'}
          >
            Maybe Later
          </button>
          <button
            onClick={handleGoToProfile}
            style={{
              padding: '12px 20px',
              background: 'linear-gradient(135deg, #dc2626 0%, #1e40af 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
            onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
          >
            Set Up Profile
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfilePromptModal;
